import React from 'react';
import DiscoverPage from './Discover/index';

const Discover: React.FC = () => {
    return <DiscoverPage />;
};

export default Discover;
